import React, { useEffect } from 'react'

const Modal = ({ open, isOpen, onClose, title, children }) => {
  const isModalOpen = open || isOpen
  
  useEffect(() => {
    // Add global style to hide scrollbar for modal scroll containers
    const styleId = 'modal-scrollbar-hide'
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style')
      style.id = styleId
      style.textContent = `
        .modal-scroll-container::-webkit-scrollbar {
          display: none;
        }
      `
      document.head.appendChild(style)
    }
  }, [])

  if (!isModalOpen) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/10 p-4 overflow-y-auto">
      <div className="relative bg-white rounded-[16px] shadow-2xl w-full max-w-3xl p-4 max-h-[98vh] flex flex-col my-auto overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-[#535862] hover:text-[#DE3C7D] focus:outline-none z-10"
          aria-label="Close"
        >
          &times;
        </button>
        <div 
          className="overflow-y-auto flex-1 modal-scroll-container" 
          style={{ 
            maxHeight: 'calc(98vh - 80px)', 
            paddingRight: '8px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {title && (
            <h2 className="text-lg font-bold text-[#030303] mb-2 pr-2">{title}</h2>
          )}
          <div style={{ paddingLeft: '4px', paddingRight: '4px' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
